export const SUPPORT_EMAIL = "support@emergent.sh";

const CDN_BASE = "https://assets.emergent.sh/assets";
const CDN_BASE_V1 = "https://assets.emergent.sh";

export const IMAGE_URLS = {
  icons: {
    emergentLogoNew: `${CDN_BASE}/emergent-logo-new.svg`,
    emergentLogoNewBlack: `${CDN_BASE}/emergent-logo-new-black.svg`,
    landingLight: `${CDN_BASE}/landing-light.png`,
    github: `${CDN_BASE}/github.svg`,
    google: `${CDN_BASE}/Google.svg`,
  },
  chips: {
    surprise: `${CDN_BASE}/chips/surprise.svg`,
  },
  common: {
    githubGreen: `${CDN_BASE}/GithubGreen.svg`,
    appleWhite: `${CDN_BASE}/apple-white.svg`,
    mail: `${CDN_BASE}/mail.svg`,
    password: `${CDN_BASE}/password.svg`,
    landingAuthStar: `${CDN_BASE}/Landing-Auth-Star.gif`,
    landingHeroE: `${CDN_BASE}/Landing-Hero-E.gif`,
    landingHeroEWebm: `${CDN_BASE}/E_transparent.webm`,
    eLogoNew: `${CDN_BASE}/E-logo-new.png`,
    alertFill: `${CDN_BASE}/alert-fill.svg`,
  },
  landingPage: {
    landingBg: `${CDN_BASE}/landing-page/landing-bg.png`,
    landingBgLight: `${CDN_BASE}/landing-page/landing-bg-light.png`,
    landingBgMobile: `${CDN_BASE}/landing-page/landing-page-mobile.png`,
    customAgents: `${CDN_BASE}/landing-page/custom-agents.png`,
    footerFiller: `${CDN_BASE}/landing-page/footer-filler.gif`,
    landingFillerBackground: `${CDN_BASE}/landing-page/landing-filler-background.png`,
    mcp: `${CDN_BASE}/landing-page/mcp.png`,
    mobile: `${CDN_BASE}/landing-page/mobile.png`,
    teams: `${CDN_BASE}/landing-page/teams.png`,
    users: `${CDN_BASE}/landing-page/users.png`,
    blackFridayPromo: `${CDN_BASE}/banner/landing page_black_friday.png`,

    blackFridayPromoWebp: `${CDN_BASE}/banner/landing_page_black_friday.webp`,
  },
  videos: {
    clouds: `${CDN_BASE}/videos/clouds.mp4`,
  },
  showcase: {
    flowerImage: `${CDN_BASE}/showcase/flower_image.jpg`,
    netflix: `${CDN_BASE}/showcase/netflix.png`,
    whiteArrow: `${CDN_BASE}/showcase/white_arrow.svg`,
    image1: `${CDN_BASE}/showcase/1.png`,
    image2: `${CDN_BASE}/showcase/2.png`,
    image3: `${CDN_BASE}/showcase/3.png`,
    image4: `${CDN_BASE}/showcase/4.png`,
    image5: `${CDN_BASE}/showcase/5.png`,
    image6: `${CDN_BASE}/showcase/6.png`,
    // webp
    image2Webp: `${CDN_BASE}/showcase/2.webp`,
    image3Webp: `${CDN_BASE}/showcase/3.webp`,
    image4Webp: `${CDN_BASE}/showcase/4.webp`,
    image6Webp: `${CDN_BASE}/showcase/6.webp`,
  },
  referral: {
    giftGreenWithoutGlow: `${CDN_BASE}/gift-green-without-glow.svg`,
    person: `${CDN_BASE}/referral/person.svg`,
  },
  phLandingPage: `${CDN_BASE_V1}/product-hunt/phLandingPage.png`,
};

export const URL_LINKS = {
  support: "https://help.emergent.sh/",
  socials: {
    discord: "https://discord.gg/X9cqNxYyG8",
  },
  helpCenter: "https://help.emergent.sh/",
  termsAndConditions: "https://app.emergent.sh/terms-of-service",
  privacyPolicy: "https://app.emergent.sh/privacy-policy",
};

export const enableProductHuntChanges = false;
